import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/api";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24">
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
    />
  </svg>
);

const GithubIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
    />
  </svg>
);

const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.63-.76 1.06-1.82.94-2.88-.91.04-2.02.61-2.67 1.37-.58.67-1.09 1.74-.95 2.78 1.02.08 2.05-.51 2.68-1.27z" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const MailIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const EasyChatLogo = () => (
  <div style={{ display: "flex", alignItems: "center", gap: "9px" }}>
    <img
      src="/logo.png"
      alt="EasyChat Logo"
      style={{ width: "32px", height: "32px", objectFit: "contain" }}
      onError={(e) => {
        e.target.style.display = 'none';
        if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
      }}
    />
    <span
      style={{
        display: "none",
        fontWeight: 800,
        fontSize: "1.25rem",
        color: "#111827",
        letterSpacing: "-0.5px"
      }}
    >
      EasyChat
    </span>
    <span
      style={{
        fontWeight: 700,
        fontSize: "1.22rem",
        color: "#0f172a",
        letterSpacing: "-0.4px",
        fontFamily: "'Inter', sans-serif"
      }}
    >
      EasyChat
    </span>
  </div>
);

const Login = ({ onLogin }) => {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await apiClient.request("/auth/login", {
        method: "POST",
        body: JSON.stringify(credentials),
      });

      const userData = {
        authenticated: true,
        token: response.access_token,
        role: response.role,
        username: response.username,
        id: response.id,
        human_agent_id: response.human_agent_id,
        ai_agent_id: response.ai_agent_id,
        tenant_id: response.tenant_id,
        assigned_ai_agents: response.assigned_ai_agents || [],
      };
      sessionStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("user", JSON.stringify(userData));

      if (response.ai_agent_id && response.ai_agent_id !== "all") {
        apiClient.setAiAgentId(response.ai_agent_id);
        localStorage.setItem("activeAiAgentId", response.ai_agent_id);
      }
      if (response.tenant_id) {
        localStorage.setItem("activeTenantId", response.tenant_id);
      }

      onLogin();
      navigate("/admin");
    } catch (err) {
      const errMsg = err?.detail || err?.message || "Invalid credentials. Please try again.";
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }
        body {
          margin: 0;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          background-color: #ffffff;
          overflow: hidden;
        }
        .page-container {
          display: flex;
          min-height: 100vh;
          width: 100vw;
          background: #ffffff;
          position: relative;
        }

        /* Ambient subtle rainbow background blur matching the reference design */
        .page-container::before {
          content: "";
          position: absolute;
          top: -20%;
          left: -15%;
          width: 70%;
          height: 80%;
          background: radial-gradient(circle, rgba(216, 235, 255, 0.45) 0%, rgba(254, 230, 240, 0.35) 45%, rgba(255, 255, 255, 0) 70%);
          filter: blur(80px);
          pointer-events: none;
          z-index: 0;
        }

        /* Left Column: Login Section */
        .left-col {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px 24px;
          z-index: 1;
        }

        .login-card {
          width: 100%;
          max-width: 380px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .login-logo-box {
          margin-bottom: 26px;
        }

        .main-headline {
          font-size: 1.72rem;
          font-weight: 700;
          line-height: 1.28;
          color: #111827;
          margin: 0 0 32px 0;
          letter-spacing: -0.025em;
        }

        .actions-stack {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        /* Google button - solid black rounded pill */
        .btn-google {
          width: 100%;
          height: 48px;
          background: #000000;
          color: #ffffff;
          border: 1px solid #000000;
          border-radius: 24px;
          font-size: 0.92rem;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.2s ease;
          box-shadow: 0 1px 3px rgba(0,0,0,0.12);
        }

        .btn-google:hover {
          background: #1f2937;
          border-color: #1f2937;
          transform: translateY(-1px);
        }

        /* Social buttons row */
        .social-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          width: 100%;
        }

        .social-btn {
          height: 46px;
          border-radius: 12px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          color: #374151;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        }

        .social-btn:hover {
          background: #f9fafb;
          border-color: #d1d5db;
          color: #111827;
          transform: translateY(-1px);
        }

        /* Continue with email button */
        .btn-email-toggle {
          width: 100%;
          height: 48px;
          background: #ffffff;
          color: #374151;
          border: 1px solid #e5e7eb;
          border-radius: 24px;
          font-size: 0.92rem;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        }

        .btn-email-toggle:hover {
          background: #f9fafb;
          border-color: #d1d5db;
          color: #111827;
        }

        .btn-email-toggle.active {
          background: #f3f4f6;
          border-color: #cbd5e1;
        }

        /* Collapsible / Animated Form Box */
        .email-form-container {
          width: 100%;
          margin-top: 8px;
          animation: slideDownFade 0.25s cubic-bezier(0.16, 1, 0.3, 1);
          text-align: left;
        }

        @keyframes slideDownFade {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .form-group {
          margin-bottom: 12px;
        }

        .form-label {
          display: block;
          font-size: 0.8rem;
          font-weight: 600;
          color: #4b5563;
          margin-bottom: 5px;
          margin-left: 2px;
        }

        .form-input {
          width: 100%;
          height: 44px;
          padding: 0 14px;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          font-size: 0.9rem;
          color: #111827;
          background: #ffffff;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
        }

        .form-input:focus {
          border-color: #111827;
          box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.08);
        }

        .btn-submit {
          width: 100%;
          height: 46px;
          background: #111827;
          color: #ffffff;
          border: none;
          border-radius: 23px;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background 0.15s ease, transform 0.15s ease;
          margin-top: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .btn-submit:hover:not(:disabled) {
          background: #000000;
          transform: translateY(-1px);
        }

        .btn-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .back-link {
          display: block;
          text-align: center;
          font-size: 0.82rem;
          color: #6b7280;
          background: none;
          border: none;
          cursor: pointer;
          margin: 10px auto 0 auto;
          text-decoration: underline;
          padding: 4px;
        }

        .back-link:hover {
          color: #111827;
        }

        .terms-text {
          font-size: 0.77rem;
          line-height: 1.45;
          color: #6b7280;
          margin-top: 32px;
        }

        .terms-text a {
          color: #111827;
          text-decoration: underline;
          font-weight: 500;
          transition: color 0.15s;
        }

        .terms-text a:hover {
          color: #4b5563;
        }

        .error-alert {
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          font-size: 0.82rem;
          padding: 8px 12px;
          border-radius: 8px;
          margin-bottom: 12px;
          text-align: center;
        }

        /* Right Column: Hero Image Showcase */
        .right-col {
          flex: 1.15;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 32px 24px 0;
          z-index: 1;
        }

        .hero-banner-wrapper {
          width: 100%;
          height: calc(100vh - 48px);
          max-height: 920px;
          background: #ffffff;
          border-radius: 28px;
          overflow: hidden;
          box-shadow: 0 20px 45px -10px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0,0,0,0.03);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        /* Responsive Breakpoints */
        @media (max-width: 960px) {
          .page-container {
            flex-direction: column;
            overflow-y: auto;
            height: auto;
          }
          body {
            overflow: auto;
          }
          .right-col {
            padding: 0 20px 40px 20px;
            width: 100%;
            flex: none;
          }
          .hero-banner-wrapper {
            height: 480px;
          }
          .left-col {
            padding: 50px 20px 30px 20px;
            flex: none;
            width: 100%;
          }
        }
      `}</style>

      <div className="page-container">
        {/* Left Login Area */}
        <div className="left-col">
          <div className="login-card">
            <div className="login-logo-box">
              <EasyChatLogo />
            </div>

            <h1 className="main-headline">
              Build websites -Apps,
              <br />
              and end-to-end software
            </h1>

            {error && <div className="error-alert">{error}</div>}

            <div className="actions-stack">
              {/* Google Button */}
              <button
                type="button"
                className="btn-google"
                onClick={() => setShowEmailForm(true)}
              >
                <GoogleIcon />
                <span>Continue with Google</span>
              </button>

              {/* Social Login Options */}
              <div className="social-row">
                <button
                  type="button"
                  className="social-btn"
                  title="Continue with GitHub"
                  onClick={() => setShowEmailForm(true)}
                >
                  <GithubIcon />
                </button>
                <button
                  type="button"
                  className="social-btn"
                  title="Continue with Apple"
                  onClick={() => setShowEmailForm(true)}
                >
                  <AppleIcon />
                </button>
                <button
                  type="button"
                  className="social-btn"
                  title="Continue with Facebook"
                  onClick={() => setShowEmailForm(true)}
                >
                  <FacebookIcon />
                </button>
              </div>

              {/* Continue with Email button */}
              <button
                type="button"
                className={`btn-email-toggle ${showEmailForm ? "active" : ""}`}
                onClick={() => setShowEmailForm(!showEmailForm)}
              >
                <MailIcon />
                <span>{showEmailForm ? "Hide email login" : "Continue with email"}</span>
              </button>

              {/* Email & Password Form (Shown when Continue with Email clicked) */}
              {showEmailForm && (
                <form className="email-form-container" onSubmit={handleLogin}>
                  <div className="form-group">
                    <label className="form-label">Email or Username</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="name@example.com or admin"
                      required
                      autoFocus
                      value={credentials.username}
                      onChange={(e) =>
                        setCredentials({ ...credentials, username: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-input"
                      placeholder="••••••••"
                      required
                      value={credentials.password}
                      onChange={(e) =>
                        setCredentials({ ...credentials, password: e.target.value })
                      }
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-submit"
                    disabled={loading}
                  >
                    {loading ? "Signing in..." : "Sign in to EasyChat"}
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </button>

                  <button
                    type="button"
                    className="back-link"
                    onClick={() => setShowEmailForm(false)}
                  >
                    Cancel
                  </button>
                </form>
              )}
            </div>

            <p className="terms-text">
              By continuing, you agree to our
              <br />
              <a href="#terms" onClick={(e) => e.preventDefault()}>Terms of Service</a> and{" "}
              <a href="#privacy" onClick={(e) => e.preventDefault()}>Privacy Policy</a>.
            </p>
          </div>
        </div>

        {/* Right Hero / Showcase Image */}
        <div className="right-col">
          <div className="hero-banner-wrapper">
            <img
              src="/easychat-login-hero.png"
              alt="EasyChat Platform Preview"
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;

